import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Wrapper from "../../components/Wrapper";
import axios from 'axios';
import { Permission } from "../../models/permission";
import { Col, Row } from 'react-bootstrap';

const RoleEdit = (props: any) => {
    const [permissions, setPermissions] = useState([]);
    const [selected, setSelected] = useState([] as number[]);
    const [name, setName] = useState('');
    const [redirect, setRedirect] = useState(false);
    const { id } = useParams();

    useEffect(() => {
        (
            async () => {
                const response = await axios.get('permissions');
                setPermissions(response.data);

                const { data } = await axios.get(`roles/${id}`);
                setName(data.name);
                setSelected(data.permissions.map((p: Permission) => p.id));
            }
        )();
    }, []);

    const check = (id: number) => {
        if (selected.some(s => s === id)) {
            setSelected(selected.filter(s => s !== id));
            return;
        }
        setSelected([...selected, id]);
    };

    const submit = async (e: SyntheticEvent) => {
        e.preventDefault();

        try {
            await axios.put(`roles/${id}`, {
                name,
                permissions: selected
            });

            setRedirect(true);
        } catch (error: any) {
            console.log(`${error.response.status}: ${error.response.message}`);
        }
    };

    if (redirect) {
        return <Navigate to={'/admin/roles'} />
    }

    return (
        <Wrapper>
            <div className="CardPedboxCover">
                <div className='AdmintopTitleCov'>
                    <div className='AdmintopTitleLeft'>
                        <h1>Modify Role</h1>
                    </div>
                    <div className='AdmintopTitleRight'></div>
                </div>
                <div className='FormCardMainbox'>
                    <form onSubmit={submit}>
                        <Row>
                            <Col md={12}>
                                <div className="InputMainComset">
                                    <label htmlFor="firstName" className="form-label">Role Name</label>
                                    <input type="text" className="form-control" id="firstName"
                                        defaultValue={name}
                                        onChange={e => setName(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="CreatroleboxSetchbox">
                                    {permissions.map((p: Permission) => {
                                        const perm_id = `perm_chkbx_${p.id}`;
                                        return (
                                            <div className="form-check" key={p.id}>
                                                <input className="form-check-input" type="checkbox" id={perm_id}
                                                    value={p.name}
                                                    checked={selected.some(s => s === p.id)}
                                                    onChange={() => check(p.id)}
                                                />
                                                <label className="form-check-label text-capitalize" htmlFor={perm_id}>
                                                    {p.name.replace('_', ' ')}
                                                </label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </Col>
                            <Col md={12}>
                                <button className="btn btn-outline-secondary">Save</button>
                            </Col>
                        </Row>
                    </form>
                </div>
            </div>
        </Wrapper>
    );
};

export default RoleEdit;